// Questions-réponses du site : UNE seule source pour la page FAQ, les blocs « Questions fréquentes »
// de chaque page (composant Faq.js, qui pose aussi le balisage FAQPage lu par Google et par les
// assistants IA) et public/llms.txt (généré par minisite-factory/build.py à partir de faq.json).
// Règles d'écriture : chaque réponse se comprend SEULE (elle sera citée hors contexte), commence
// par la réponse elle-même, nomme le produit, donne le chiffre. Rien qui ne soit vrai aujourd'hui.
import DATA from './faq.json';

export const FAQ_GROUPES = DATA.groupes;

const parCle = Object.fromEntries(DATA.groupes.flatMap((g) => g.questions.map((q) => [q.id, q])));

// Sélections par page : liste d'identifiants de questions (faq.json).
export const FAQ_PAGES = DATA.pages;

export const faqDe = (page) => (DATA.pages[page] || []).map((id) => parCle[id]).filter(Boolean);
